import comp from "./ImageViewer";
export default comp;
